import { Helper } from '../../Helper';
export class ArrayLengthHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.emitOp(node, 'ARRAYSIZE');
    }
}

//# sourceMappingURL=ArrayLengthHelper.js.map
